import * as React from 'react';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import { RouteProps } from 'react-router';
import { IStore } from 'redux/IStore';
import {
	getAdminShops,
	setSortFilter,
	setSearchFilter,
	setStatusFilter,
	resetData,
	resetFilters,
} from 'modules/shop/shops';
import { IShopsData, IShopsAction } from 'models/shop/shops';
import { showModal, closeModal } from 'modules/modal';
import { IItemCardList } from 'models/itemcard/itemcardlist';
import * as c from 'models/constants';
import { IInfiniteScrollProps } from 'models/infinitescroll';
import { ItemCardList } from 'components';
import { ErrorPage } from 'containers';
import { AdminShopsSort } from 'models/enums/sortvalues';
import { IModalAction } from 'models/modal';
import { FilteredPage } from 'components/PortalStructure';
import { getShopCard } from 'modules/shop/shopcard';
import { IShopCardAction } from 'models/shop/shopcard';

interface IProps {
	shopsData?: IShopsData;

	/* function props */
	route?: RouteProps;
	routeParams?: IShopsRouteParams;
	location?: Location;
	getAdminShops?: () => IShopsAction;
	setSortFilter?: (sortFilter: number) => IShopsAction;
	setSearchFilter?: (keywordFilter: string) => IShopsAction;
	setLanguageFilter?: (languageKeyFilter: string) => IShopsAction;
	setStatusFilter?: (statusFilter: string) => IShopsAction;
	resetData?: () => IShopsAction;
	resetFilters?: () => IShopsAction;
	getShopCard?: (id: string) => IShopCardAction;
	showModal?: (modalType: string, modalProps: any) => IModalAction;
	closeModal?: () => IModalAction;
	t?: (key: string) => string;
}

interface IShopsRouteParams {
	keyword?: string;
	id?: string;
}

@connect(
	(state: IStore) => ({
		shopsData: state.shops,
	}),
	(dispatch) => ({
		getAdminShops: () => dispatch(getAdminShops()),
		setSortFilter: (sort: number) => dispatch(setSortFilter(sort)),
		setSearchFilter: (keyword: string) => dispatch(setSearchFilter(keyword)),
		setStatusFilter: (status: string) => dispatch(setStatusFilter(status)),
		resetData: () => dispatch(resetData()),
		resetFilters: () => dispatch(resetFilters()),
		getShopCard: (id: string) => dispatch(getShopCard(id)),
		closeModal: () => dispatch(closeModal()),
		showModal: (modalType: string, modalProps: any) => dispatch(showModal(modalType, modalProps)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class AdminShops extends React.Component<IProps> {
	private searchValue: string = '';

	constructor(props) {
		super(props);

		this.loadMoreData = this.loadMoreData.bind(this);
		this.handleSortChange = this.handleSortChange.bind(this);
		this.handleSearchValueChange = this.handleSearchValueChange.bind(this);
		this.handleSearchShops = this.handleSearchShops.bind(this);
		this.handleSearchEnterPress = this.handleSearchEnterPress.bind(this);
	}

	public componentDidMount() {
		this.props.setStatusFilter(this.props.route.path);
		this.props.getAdminShops();
	}

	public componentDidUpdate() {
		if (
			this.props.route &&
			this.props.shopsData.statusFilter &&
			this.props.shopsData.statusFilter !== this.props.route.path
		) {
			this.props.setStatusFilter(this.props.route.path);
			this.props.getAdminShops();
		}

		if (
			this.searchValue.length === 0 &&
			this.props.shopsData.keywordFilter &&
			this.props.shopsData.keywordFilter.length > 0
		) {
			this.searchValue = this.props.shopsData.keywordFilter;
		}
	}

	public componentWillUnmount() {
		this.props.resetData();
		this.props.resetFilters();
	}

	public loadMoreData() {
		this.props.getAdminShops();
	}

	public handleSortChange(value: number) {
		this.props.setSortFilter(value);
		this.props.getAdminShops();
	}

	private handleSearchValueChange(value: string) {
		this.props.setSearchFilter(value);
	}

	private handleSearchShops() {
		this.props.getAdminShops();
	}

	private handleSearchEnterPress() {
		this.props.getAdminShops();
	}

	public render() {
		if (this.props.shopsData.error) {
			return <ErrorPage {...this.props} message={this.props.shopsData.message} />;
		}

		const { items, itemsPage, keywordFilter, sortFilter } = this.props.shopsData;
		const { t } = this.props;

		let searchFilter: string = keywordFilter;
		if (!searchFilter) {
			searchFilter = '';
		}

		let shops = [];

		if (this.props.shopsData !== undefined || this.props.shopsData !== null) {
			shops = this.props.shopsData.items;
		}

		const infiniteScrollProps: IInfiniteScrollProps = {
			dataLength: items.length,
			next: this.loadMoreData,
			hasMore: itemsPage.totalItems > items.length,
			loader: <h4>{t('BSPortal_Common_Loading')} </h4>,
		};

		const listProps: IItemCardList = {
			items: shops,
			itemType: c.NODE_TYPE_ADMIN_SHOP_ITEM_CARD,
			isInfiniteScroll: true,
			infiniteScrollProps,
			useIntersectionObserver: true,
			viewItem: (id: string) => this.props.getShopCard(id),
		};

		const sortOptions = [];
		for (const n in AdminShopsSort) {
			if (typeof AdminShopsSort[n] === 'number') {
				sortOptions.push({ key: AdminShopsSort[n], value: t('AdminShops_Sort_' + n) });
			}
		}

		const topBarProps: object = {
			searchKeyword: keywordFilter,
			rightFilterTitle: t('BSPortal_Common_Filter_SortBy'),
			rightFilterOptions: sortOptions,
			rightFilterKey: sortFilter,
			onSearchButtonClick: this.handleSearchShops,
			onSearchEnterPress: this.handleSearchEnterPress,
			onSearchValueChange: this.handleSearchValueChange,
			onRightFilterChange: this.handleSortChange,
		};

		return (
			<FilteredPage filterBarOptions={topBarProps}>
				<ItemCardList {...listProps} />
			</FilteredPage>
		);
	}
}
export { AdminShops };
